import React, { useEffect } from "react";
import Header from "./Header/Header";
import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { applicationActions } from "../store/application-slice";
import { checkLogin, initLmsUser } from "../store/auth-actions";
import classes from "./Layout.module.css"
import goToComputer from '../assests/go-to-computer.png'
import useAnalytics from "./lms-shared/hooks/useAnalytics";
import DynamicMessage from "./lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "./lms-shared/models/DynamicMessageTypeEnum";

const Layout = () => {
  const dispatch = useDispatch();
  const { applicationId, colorsChanges } = useSelector(state => state.application);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const texts = useSelector((state) => state.translate.texts);
  const direction = useSelector((state) => state.translate.direction);
  const uiData = useSelector((state) => state.general.uiData);
  const isStudent = useSelector((state) => state.auth.isStudent);

  const { applictionName } = useParams();
  useEffect(() => {
    dispatch(checkLogin(applictionName))
  }, [dispatch])


  useEffect(() => {
    if (applicationId && isAuthenticated) {
      dispatch(initLmsUser())
      changeColors()
    }
  }, [dispatch, applicationId, isAuthenticated])

  const changeColors = () => {
    if (colorsChanges) {
      document.documentElement.style.setProperty('--main-color', colorsChanges.mainColor);
      document.documentElement.style.setProperty('--messages-color', colorsChanges.messagesColor);
      document.documentElement.style.setProperty('--icons-color', colorsChanges.iconsColor);
      document.documentElement.style.setProperty('--level-name-color', colorsChanges.levelName);
      document.documentElement.style.setProperty('--icon-text-color', colorsChanges.iconTextColor);
    }
  };

  useEffect(() => {
    if (uiData) {
      dispatch(applicationActions.setInitial({ applictionName, uiData }))
    }
  }, [dispatch, uiData])

  useAnalytics()

  return <div className={direction}>
    {
      isStudent && <DynamicMessage type={DynamicMessageTypeEnum.NoEnter} content={texts.onlyTeachingStafAreAllowedToEnter} title={texts.noPermissionForThisArea} />
    }
    <div className="routes">
      <div className={classes.GoToComputerWrapper}>
        <div className={classes.GoToComputerBackground}></div>
        <div className={classes.GoToComputerContent}>
          <img src={goToComputer} className={classes.GoToComputerImg} alt="GoToComputerIcon" />
          <div className={classes.GoToComputerText}>{texts.siteOnComputer}</div>
        </div>
      </div>
      <div className={classes.ResponsiveComputerWrapper}>
        <Header></Header>
        <Outlet></Outlet>
      </div>
    </div>
  </div>
}
export default Layout;